import React from "react";
import { Subtitle } from "../Subtitle";
import "./styles.scss";

interface Section2Props {}

function Section2({}: Section2Props) {
  return (
    <section className="section2">
      <div>
        <Subtitle text="A gente ama facilitar a forma que você paga por suas compras!" />

        <p className="paragraphSection2">
          E você é um convidado exclusivo para testar a nossa nova solução para
          pagamentos parcelados sem cartão. Você compra em uma das lojas
          indicadas pela Koin e a gente parcela essa compra pra você.
        </p>
      </div>
    </section>
  );
}

export { Section2 };
